import { createContext, useContext, useState, useEffect } from "react";

const FilterContext = createContext();
export const useFilters = () => useContext(FilterContext);

export const FilterProvider = ({ children }) => {
  // Ініціалізація з localStorage
  const [account, setAccount] = useState(() => localStorage.getItem("selectedAccount") || null);
  const [marketplace, setMarketplace] = useState(() => localStorage.getItem("selectedMarketplace") || null);

  // Автозбереження у localStorage при зміні
  useEffect(() => {
    //console.log(account);
    //if (account)
    localStorage.setItem("selectedAccount", account);
  }, [account]);

  useEffect(() => {
    if (marketplace) localStorage.setItem("selectedMarketplace", marketplace);
  }, [marketplace]);

  return (
    <FilterContext.Provider value={{ account, setAccount, marketplace, setMarketplace }}>
      {children}
    </FilterContext.Provider>
  );
};
